import React, { useState, useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';

const LinkedinDispatches = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const response = await fetch('/data/linkedin-posts.json');
        const data = await response.json();
        const sortedPosts = data.posts.sort((a, b) => 
          new Date(b.date) - new Date(a.date)
        );
        setPosts(sortedPosts);
      } catch (error) {
        console.error('Failed to load LinkedIn posts:', error);
      }
    };

    loadPosts();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  if (posts.length === 0) return null;

  return (
    <section className="py-24 px-6 border-t border-teal-500/10 bg-abyss-950 relative z-20">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-baseline mb-12 font-mono border-b border-abyss-800 pb-4">
          <span className="text-teal-400 text-xs tracking-[0.15em]">FIELD DISPATCHES</span>
          <span className="text-sand-50/30 text-[10px]">// linkedin.com/in/jaygut</span>
        </div>

        {/* Dispatches Grid */}
        <div className="space-y-0">
          {posts.map((post) => (
            <a 
              key={post.id}
              data-testid={`linkedin-dispatch-${post.id}`}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block py-8 border-b border-sand-50/5 hover:border-teal-500/30 transition-all group"
            >
              <h3 className="text-xl md:text-2xl text-sand-50 font-serif mb-3 group-hover:text-teal-400 transition-colors font-light leading-tight flex items-start justify-between gap-4">
                {post.title}
                <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity mt-1 shrink-0 text-teal-500" />
              </h3>
              
              <div className="flex flex-wrap gap-x-4 gap-y-2 font-mono text-xs text-sand-50/40 tracking-wide mb-4">
                <span className="text-teal-500/60">[{formatDate(post.date)}]</span>
                {post.tags.map(tag => (
                  <span key={tag} className="hover:text-teal-400/80 transition-colors">#{tag}</span>
                ))}
              </div>

              {post.excerpt && (
                <p className="text-sm text-sand-50/60 leading-relaxed font-light max-w-3xl group-hover:text-sand-50/80 transition-colors">
                  {post.excerpt}
                </p>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LinkedinDispatches;
